<template>
  <div>
    <v-row>
      <v-col cols="11" class="pr-0">
        <div class="question-wrapper pa-3">
          <v-row no-gutters>
            <v-col cols="2">
              <span>{{ question.technicalCode }}</span>
            </v-col>
            <v-col cols="10">
              <div class="question-title white caption w-100">
                <p>{{ question.question }}</p>
                <div class="icon-box">
                  <v-icon class="question-explanation" color="headColor" @click="explainToggle = !explainToggle">
                    mdi-chat-processing-outline
                  </v-icon>
                  <v-menu
                    open-on-hover
                    right
                    offset-x
                    nudge-right="20"
                    close-delay="100"
                    v-if="question.extraInformation !== null"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon color="info" dark v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span class="subtitle-2 px-2" v-html="question.extraInformation"></span>
                  </v-menu>
                </div>
              </div>
              <bdo-radio
                :selected-radio="
                  question.answers &&
                  question.answers[0] &&
                  question.answers[0].answerOptions &&
                  question.answers[0].answerOptions[0]
                    ? question.answers[0].answerOptions[0].optionValue
                    : null
                "
                :radio.sync="selectedRadio"
                :label="question.question"
                :group-id="question.id"
                :radio-group="question.answerOptions"
                :disabled="disabled"
              />
              <div class="explain-wrapper mt-8" v-show="explainToggle">
                <p>Explanation</p>
                <textarea
                  class="text-box"
                  name=""
                  id=""
                  cols="30"
                  rows="5"
                  v-model="explanation"
                  :disabled="disabled"
                  @input="updateExplanation"
                ></textarea>
              </div>
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import helpers from '@/plugins/helpers'
import bdoRadio from './radio.vue'
export default {
  components: {
    bdoRadio
  },
  props: {
    question: {
      type: Object,
      default: () => {}
    },
    index: {
      type: Number,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    giveanswerarr: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    questions: null,
    selectedRadio: {},
    selectedRadioOption: '',
    differentValue: false,
    differentText: '',
    selectedDropdown: {},
    answer: {},
    clearSelected: false,
    checkboxAnswers: [],
    explainToggle: true,
    explanation: ''
  }),
  computed: {
    textAreaRules() {
      let rules = []
      const required = value => !!value || 'Field is required'
      rules.push(required)
      return rules
    }
  },
  watch: {
    async selectedRadio() {
      this.getNextQuestion()
    }
  },
  mounted() {
    this.explanation = this.question.answers && this.question.answers[0] ? this.question.answers[0].remarks : null
  },
  methods: {
    async getNextQuestion() {
      const questionnaireId = this.$route.params.id
      const showOnAnsweroptionsId = this.selectedRadio.id
      let query = `{
        oneQuestion(where:{_and:[
          {questionSubject:{questionnaire:{customerQuestionnaires:{id:{eq:${questionnaireId}}}}}},
          {showOnAnsweroptions:{id:{eq: ${showOnAnsweroptionsId}}}}
        ]}){
          id
          orderIndex
          active
          extraInformation
          helpText
          question
          questionCode
          questionType 
          required
          showAfterQuestion{
            id
            question
          }
          showOnAnsweroptions{
            id
            optionValue
          }
          answerOptions{
            id
            orderIndex
            defaultSelected
            displayStr
            optionValue
          }
          questionSubject{
            id
            name
            description
            active
            orderIndex
          }
          technicalCode
        }
      }`
      let result = await helpers.fetchGraph(query)
      this.appendAnswer(this.selectedRadio, result)
    },

    appendAnswer(answerOption, result) {
      if (result.data.oneQuestion !== null) {
        this.$emit('next-question', {
          question: this.question,
          answerOption: answerOption,
          explanation: this.explanation,
          result: result.data.oneQuestion
        })
      } else {
        this.$emit('last-question', {
          question: this.question,
          answerOption: answerOption,
          explanation: this.explanation
          //result: result.data.oneQuestion
        })
      }
    },
    updateExplanation() {
      this.$emit('update-explanation', {
        question: this.question,
        explanation: this.explanation
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/style/_variables.scss';
.chipwidth {
  min-width: 24px;
  height: 24px !important;
}

.text-box {
  border: 1px solid #cccccc;
  width: 100%;
  padding: 4px;
}

.question-title {
  display: flex;
  justify-content: space-between;

  .question-explanation {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }

  .question-explanation:after {
    background-color: transparent;
  }
}

.question-help-col {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 24px;
}
</style>
